export default __webpack_public_path__ + "static/media/UF.d5e94626.jpeg";